(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/engine/assets/javascripts/utils/jackpots.js') >= 0) return;  svs.modules.push('/components/tipsen/engine/assets/javascripts/utils/jackpots.js'); "use strict";

const getJackpotsFromDraw = draw => (draw === null || draw === void 0 ? void 0 : draw.jackpots) || [];
const getJackpotByLogic = (draw, logicFunction) => {
  const jackpotFromDraw = getJackpotsFromDraw(draw)[0];
  return logicFunction(jackpotFromDraw);
};
const getJackpotFromDraw = draw => getJackpotByLogic(draw, jackpotFromDraw => !(jackpotFromDraw !== null && jackpotFromDraw !== void 0 && jackpotFromDraw.defaultJackpot) ? jackpotFromDraw : '');
const getGuaranteedJackpotFromDraw = draw => getJackpotByLogic(draw, jackpotFromDraw => jackpotFromDraw !== null && jackpotFromDraw !== void 0 && jackpotFromDraw.defaultJackpot ? jackpotFromDraw : '');
const _exports = {
  getJackpotsFromDraw,
  getJackpotFromDraw,
  getGuaranteedJackpotFromDraw
};
if (svs.isServer) {
  module.exports = _exports;
} else {
  setGlobal('svs.components.tipsen.engine.utils.jackpots', _exports);
}
 })(window);